import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  OnboardingProcessStageRequiredDocuments,
  OnboardingProcessStageSubmittedDocuments,
} from '@interfaces/a-organizar/onboardingCompanyInformation';
import { isPendingDocument } from '@features/dashboard/document-analysis-company/helpers/document-analysis-metrics';
import { AnalysisDocumentPillComponent } from '@features/dashboard/document-analysis-company/components/analysis-document-pill/analysis-document-pill.component';

@Component({
  selector: 'app-analysis-document-row',
  standalone: true,
  imports: [CommonModule, AnalysisDocumentPillComponent],
  templateUrl: './analysis-document-row.component.html',
  styleUrls: ['./analysis-document-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalysisDocumentRowComponent {
  @Input({ required: true }) documentLabel!: string;
  @Input({ required: true }) requiredDocument!: OnboardingProcessStageRequiredDocuments;
  @Input() submissionTooltips: Record<string, string> = {};
  @Input() analysisTooltips: Record<string, string> = {};
  @Input() statusLabels: { approved: string; rejected: string; pending: string } = {
    approved: '',
    rejected: '',
    pending: '',
  };
  @Input() noDocumentSentLabel = '';
  @Output() documentSelected = new EventEmitter<OnboardingProcessStageSubmittedDocuments>();

  get documents(): OnboardingProcessStageSubmittedDocuments[] {
    return this.requiredDocument.submittedDocuments ?? [];
  }

  get pendingCount(): number {
    return this.documents.filter(isPendingDocument).length;
  }

  /** `1 documento · 1 pendente` / `1 documento · nada pendente` / `Nenhum documento enviado` */
  get summary(): string {
    const total = this.documents.length;

    if (total === 0) {
      return this.noDocumentSentLabel;
    }

    const documentPart = total === 1 ? '1 documento' : `${total} documentos`;
    const pending = this.pendingCount;
    const pendingPart =
      pending === 0 ? 'nada pendente' : pending === 1 ? '1 pendente' : `${pending} pendentes`;

    return `${documentPart} · ${pendingPart}`;
  }

  tooltipFor(
    map: Record<string, string>,
    document: OnboardingProcessStageSubmittedDocuments
  ): string {
    return document.id ? (map[document.id] ?? '') : '';
  }
}
